import React, { useState } from "react";
import { useAuth } from "../../context/AuthContext";
import PostList from "./PostList";
import PostDetail from "./PostDetail";
import "./MessageBoard.css";

const categories = [
  {
    id: "travelling",
    icon: "✈️",
    name: "Travelling to Sri Lanka",
    nameSi: "ශ්‍රී ලංකාවට සංචාරය",
    description: "Share travel tips, ask questions about visiting",
  },
  {
    id: "learning",
    icon: "📚",
    name: "Learning Sinhala",
    nameSi: "සිංහල ඉගෙනීම",
    description: "Tips, resources, and questions about learning",
  },
  {
    id: "travel-tips",
    icon: "💡",
    name: "Tips for Travel",
    nameSi: "සංචාරක උපදෙස්",
    description: "Practical advice for travelers",
  },
  {
    id: "food",
    icon: "🍛",
    name: "Food",
    nameSi: "ආහාර",
    description: "Cuisine, recipes, restaurant recommendations",
  },
  {
    id: "expats",
    icon: "🌍",
    name: "Sri Lankan Expats",
    nameSi: "විදේශගත ශ්‍රී ලාංකිකයන්",
    description: "Connect with Sri Lankans living abroad",
  },
  {
    id: "culture",
    icon: "🎭",
    name: "Culture & Traditions",
    nameSi: "සංස්කෘතිය හා සම්ප්‍රදාය",
    description: "Discuss customs and traditions",
  },
  {
    id: "sports",
    icon: "🏏",
    name: "Sports",
    nameSi: "ක්‍රීඩා",
    description: "Cricket, rugby, and Sri Lankan sports",
  },
  {
    id: "general",
    icon: "💬",
    name: "General Discussion",
    nameSi: "සාමාන්‍ය සාකච්ඡාව",
    description: "Any related topic",
  },
];

function MessageBoard() {
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedPost, setSelectedPost] = useState(null);
  const { user } = useAuth();

  const handleCategoryClick = (category) => {
    setSelectedCategory(category);
    setSelectedPost(null);
  };

  const handleBackToCategories = () => {
    setSelectedCategory(null);
    setSelectedPost(null);
  };

  const handleBackToList = () => {
    setSelectedPost(null);
  };

  const handlePostClick = (post) => {
    setSelectedPost(post);
  };

  // Post Detail View
  if (selectedPost) {
    return (
      <div className="message-board">
        <PostDetail
          post={selectedPost}
          category={selectedCategory}
          onBack={handleBackToList}
          user={user}
        />
      </div>
    );
  }

  // Post List View
  if (selectedCategory) {
    return (
      <div className="message-board">
        <PostList
          category={selectedCategory}
          onBack={handleBackToCategories}
          onPostClick={handlePostClick}
          user={user}
        />
      </div>
    );
  }

  // Categories View (default)
  return (
    <div className="message-board">
      <div className="message-board-header">
        <h1>
          <span className="header-icon">💬</span>
          Community
        </h1>
        <p className="header-subtitle">ප්‍රජාව</p>
        <p className="header-description">
          Connect with fellow learners, share experiences, and ask questions
        </p>
      </div>

      <div className="categories-grid">
        {categories.map((category) => (
          <button
            key={category.id}
            className="category-card"
            onClick={() => handleCategoryClick(category)}
          >
            <span className="category-icon">{category.icon}</span>
            <div className="category-info">
              <h3>{category.name}</h3>
              <p className="category-name-si">{category.nameSi}</p>
              <p className="category-description">{category.description}</p>
            </div>
            <span className="category-arrow">→</span>
          </button>
        ))}
      </div>
    </div>
  );
}

export default MessageBoard;
